import Service, { inject as service } from '@ember/service';
import { loadScript } from 'sh-www/utils/script-loader';
import ENV from 'sh-www/config/environment';

/**
 * Service to request scoped permissions on behalf of the user
 *
 * EXAMPLE USAGE
 @task
 googleSSO() {
    yield this.googleGIS.load();
    const client = this.googleGIS.client(
      ['https://www.googleapis.com/auth/calendar.readonly'],
      this.onGoogleSSO
    );
    const code = client.requestCode();
    console.log(code);
  },
 */
class GoogleGISService extends Service {
  @service('error-tracker') errorTracker;

  #loaded = false;
  #promise = null;

  get loaded() {
    return this.#loaded;
  }

  /**
   *
   * @param scopes
   * @param callback
   * @returns {null|*}
   */
  client(scopes, callback) {
    if (!this.#loaded) {
      return null;
    }

    return window.google.accounts.oauth2.initCodeClient({
      client_id: ENV.GOOGLE_CLIENT_ID,
      scope: scopes.join(' '),
      ux_mode: 'popup',
      callback: callback,
    });
  }

  load() {
    return this.#promise ??= loadScript(`https://accounts.google.com/gsi/client`)
      .then(() => {
        this.#loaded = true;
      })
      .catch((e) => {
        this.errorTracker.error(e, this, 'unable to load google gis client');
        throw e;
      });
  }
}

export default GoogleGISService;
